import script from "./HrListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HrListItem.vue?vue&type=script&setup=true&lang=js"

import "./HrListItem.vue?vue&type=style&index=0&id=660140ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660140ec"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QList from 'quasar/src/components/item/QList.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QList});qInstall(script, 'directives', {Ripple});
